export { DMS_MODULE, MODULE_API } from '../constants';
export const NAME = 'NdPohyb';
export const CRUMB_LABEL_KEY = 'edtNDPohyb';
export const API_POHYB_ZAKAZKA = 'NdpohybZakazka';

export const ND_NR = 'ND_NR';

export const GRID_COLUMNS = {
	ND_NR,
};
